import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;

  &:hover span:first-child {
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

const Label = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const Count = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.16);
  font-size: 11px;
  font-weight: 600;
  color: #b45309;
`;

interface RefundsShortcutProps {
  count: number;
  onClick: () => void;
  /** Domyślnie „Zwrot środków". */
  label?: string;
  /** Nadpisanie badge'a, np. „12+" gdy okno zapytań jest przycięte. */
  countLabel?: string;
}

/**
 * Zwarty link z licznikiem — ten sam na rezerwacjach wellness i na zamówieniach.
 * Klik otwiera listę spraw do zwrotu.
 */
export const RefundsShortcut: FC<RefundsShortcutProps> = ({
  count, onClick, label, countLabel,
}) => {
  const { t } = useTranslation();

  if (count <= 0) return null;

  return (
    <Trigger type="button" onClick={onClick}>
      <Label>{label ?? t('orders.refundsLink', 'Zwrot środków')}</Label>
      <Count>{countLabel ?? count}</Count>
    </Trigger>
  );
};
